// extracted by mini-css-extract-plugin
export default {"container":"_z-z","brandName":"aA-z","productName":"bA-z","aboveGalleryInfo":"cA-z","belowGalleryInfo":"dA-z","breakLongProductName":"eA-z"};